module.exports = __webpack_public_path__ + "img/warning-less.177c2dd5.svg";